// src/components/AccountCreation/Step1_SubscriptionPlan.js
import React from 'react';
import { PLANS_CONFIG } from './constants';

const Step1_SubscriptionPlan = ({ data, setData, nextStep }) => {
  const { region, deviceType, plan, frequency } = data.subscription;
  const availablePlans = PLANS_CONFIG[region]?.[deviceType] || {};
  const availableFrequencies = availablePlans[plan] || {};
  const price = availableFrequencies[frequency] || 0;

  const handleSelectionChange = (field, value) => {
    const newSubscription = { ...data.subscription, [field]: value };
    if (field === 'region' || field === 'deviceType') {
      const newAvailablePlans = PLANS_CONFIG[newSubscription.region]?.[newSubscription.deviceType] || {};
      const firstPlan = Object.keys(newAvailablePlans)[0] || '';
      newSubscription.plan = firstPlan;
      const newAvailableFrequencies = newAvailablePlans[firstPlan] || {};
      newSubscription.frequency = Object.keys(newAvailableFrequencies)[0] || '';
    }
    if (field === 'plan') {
        const newAvailableFrequencies = availablePlans[value] || {};
        newSubscription.frequency = Object.keys(newAvailableFrequencies)[0] || '';
    }
    setData(prevData => ({ ...prevData, subscription: newSubscription }));
  };

  return (
    <div>
      <h2 className="text-center fw-bold mb-4">Create Your Subscription</h2>
      <div className="row g-3">
        <div className="col-md-6"><label htmlFor="region" className="form-label fw-semibold">Region</label><select id="region" className="form-select form-select-lg" value={region} onChange={(e) => handleSelectionChange('region', e.target.value)}>{Object.keys(PLANS_CONFIG).map(r => <option key={r} value={r}>{r}</option>)}</select></div>
        <div className="col-md-6"><label htmlFor="deviceType" className="form-label fw-semibold">Device Type</label><select id="deviceType" className="form-select form-select-lg" value={deviceType} onChange={(e) => handleSelectionChange('deviceType', e.target.value)}>{Object.keys(PLANS_CONFIG[region] || {}).map(d => <option key={d} value={d}>{d}</option>)}</select></div>
        <div className="col-md-6"><label htmlFor="plan" className="form-label fw-semibold">Plan</label><select id="plan" className="form-select form-select-lg" value={plan} onChange={(e) => handleSelectionChange('plan', e.target.value)} disabled={!Object.keys(availablePlans).length}>{Object.keys(availablePlans).map(p => <option key={p} value={p}>{p}</option>)}</select></div>
        <div className="col-md-6"><label htmlFor="frequency" className="form-label fw-semibold">Billing Frequency</label><select id="frequency" className="form-select form-select-lg" value={frequency} onChange={(e) => handleSelectionChange('frequency', e.target.value)} disabled={!Object.keys(availableFrequencies).length}>{Object.keys(availableFrequencies).map(f => <option key={f} value={f} className="text-capitalize">{f}</option>)}</select></div>
      </div>
      <div className="card bg-light text-center mt-4 p-3"><p className="text-muted mb-0">Your Price</p><p className="h2 fw-bold text-dark mb-0">${price}<span className="h5 fw-normal">/{frequency.replace('ly', '')}</span></p></div>
      <div className="text-end mt-4">
        <button onClick={nextStep} className="btn btn-primary" disabled={!plan || !frequency}>Next: User Details</button>
      </div>
    </div>
  );
};

export default Step1_SubscriptionPlan;
